export default function BrandMark({ size = 38 }) {
  // Aurora-inspired sigil: vertical N reflected with diagonal bronze line.
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" aria-label="Borealis Reserve">
      <defs>
        <linearGradient id="bm-bronze" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#C39B66" />
          <stop offset="100%" stopColor="#A78049" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="38" height="38" fill="none" stroke="url(#bm-bronze)" strokeWidth="1" />
      <path d="M 10 30 L 10 12 L 30 28 L 30 10" stroke="url(#bm-bronze)" strokeWidth="1.6" fill="none" strokeLinecap="square" />
      <circle cx="10" cy="10" r="1.8" fill="#C39B66" />
      <circle cx="30" cy="30" r="1.8" fill="#C39B66" />
    </svg>
  );
}
